module.exports = __webpack_public_path__ + "img/seafood_allergy-off.d15e7171.svg";